import CreateProcessLegal from "./CreateProcess.vue"
export default CreateProcessLegal